export const ListUtils = {
  PAGE_PREV: 'prev',
  PAGE_NEXT: 'next',

  PAGE_LIMIT: 5, // 페이지 표시 개수
  PAGE_INDEX: 1, // 페이지 인덱스
  PAGE_TOTAL: 0, // 총 페이지 수
  PAGE: 1, // 현재 페이지
  LIST_TOTAL: 0, // 리스트 전체 개수
  LIST_PER: 10, // 리스트 당 개수
  LIST_SORT: 'desc', // 리스트 정렬 방식
  LIST_SORT_COLUMN: '', // 리스트 정렬 대상
  WITH_DEVICE: 'Y',
  SEARCH_COLUMN: '', // 리스트 검색 대상
  SEARCH_NAME: '', // 리스트 검색값
  CATEGORIES: undefined, // 영상 제작 시 선택된 카테고리

  TAG: '',
};

export const per = (value) => {
  ListUtils.PAGE_INDEX = 1;
  ListUtils.PAGE = 1;
  ListUtils.LIST_PER = value;
};

export const sort = (target, type) => {
  ListUtils.LIST_SORT = target;
  ListUtils.LIST_SORT_COLUMN = type;
};

export const search = (text) => {
  if (text.indexOf('#') !== -1) {
    const textArr = text.split('#');
    const tempTag = textArr[1];
    ListUtils.TAG = tempTag;
    ListUtils.SEARCH_NAME = '';
  } else {
    ListUtils.TAG = '';
    ListUtils.SEARCH_NAME = text;
  }
  ListUtils.PAGE_INDEX = 1;
  ListUtils.PAGE = 1;
};

export const control = (page, listPer, total) => {
  ListUtils.LIST_PER = listPer;
  ListUtils.LIST_TOTAL = total;
  ListUtils.PAGE = page;
  ListUtils.PAGE_TOTAL = Math.ceil(total / listPer);

  let isPrev = false;
  let isNext = false;

  if (ListUtils.PAGE_INDEX > 1) {
    isPrev = true;
  }
  if (ListUtils.PAGE_INDEX * ListUtils.PAGE_LIMIT < ListUtils.PAGE_TOTAL) {
    isNext = true;
  }
  return { prev: isPrev, next: isNext, pageTotal: ListUtils.PAGE_TOTAL };
};

export const pageDirect = (direct) => {
  const index = ListUtils.PAGE_INDEX;
  let is = false;

  if (ListUtils.PAGE_PREV === direct) {
    if (index > 1) {
      ListUtils.PAGE_INDEX -= 1;
      ListUtils.PAGE = ListUtils.PAGE_LIMIT * ListUtils.PAGE_INDEX;
      is = true;
    }
  } else if (ListUtils.PAGE_NEXT === direct) {
    if (index * ListUtils.PAGE_LIMIT < ListUtils.PAGE_TOTAL) {
      ListUtils.PAGE_INDEX += 1;
      if (ListUtils.PAGE_LIMIT * ListUtils.PAGE_INDEX > ListUtils.PAGE_TOTAL) {
        ListUtils.PAGE = ListUtils.PAGE_TOTAL;
      } else {
        ListUtils.PAGE = ListUtils.PAGE_LIMIT * ListUtils.PAGE_INDEX;
      }
      is = true;
    }
  }

  return is;
};

export const getPagination = () => {
  const pages: number[] = [];
  let total = ListUtils.PAGE_LIMIT;
  if (ListUtils.PAGE_LIMIT > ListUtils.PAGE_TOTAL) {
    total = ListUtils.PAGE_TOTAL;
  }

  if (ListUtils.PAGE_LIMIT * ListUtils.PAGE_INDEX > ListUtils.PAGE_TOTAL) {
    total =
      ListUtils.PAGE_TOTAL - ListUtils.PAGE_LIMIT * (ListUtils.PAGE_INDEX - 1);
  }

  const startIndex = ListUtils.PAGE_LIMIT * (ListUtils.PAGE_INDEX - 1);

  for (let i = 1; i <= total; i += 1) {
    pages.push(startIndex + i);
  }

  return pages;
};

export default {
  ListUtils,
  per,
  sort,
  search,
  control,
  pageDirect,
  getPagination,
};
